import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { APIStatus } from "../../constants";
import { Table } from "../../plugins/table";
import { columns } from "./column";
import { PaginationWithNumber } from "../../modal/common";
import { QueTypeAndWeightage } from "../../modal/college";
import { AddNewQuestiontypeWeightage } from "./modal";
import { clearDeleteQueTypeAndWeightage, clearGetAllQueTypeAndWeightage } from "../../services/settings/settings.slice";
import { delQueTypeAndWeightage, getAllQueTypeAndWeightage } from "../../services/settings/settings.service";
import { deleteModal } from "../../plugins/delete-modal";
import NegativeMark from "./negativeMark";
import "./settings.scss";

export interface stateType {
	questionType: string;
	weightage: string;
	isAddNewModalOpen: boolean;
	isUpdateNewModalOpen: boolean;
	updateQuestionType: string;
	updateWeightage: number | null;
	updateId: number | null;
}

export const Settings: React.FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const dataLoading = useAppSelector((store) => store.college.dataLoading);
	const totalCount = useAppSelector((store) => store.college.totalCount);
	const tableData = useAppSelector((store) => store.settings.queTypeAndWeightage);
	const createQuestionTypeAndWeightageComplete = useAppSelector(
		(store) => store.settings.createQuestionTypeAndWeightageComplete
	);
	const updateQueTypeAndWeightageCompleted = useAppSelector(
		(store) => store.settings.updateQueTypeAndWeightageCompleted
	);

	const delQueTypeAndWeightageComplete = useAppSelector((store) => store.settings.delQueTypeAndWeightageComplete);
	const [state, setState] = useState<stateType>({
		questionType: "",
		weightage: "",
		isAddNewModalOpen: false,
		isUpdateNewModalOpen: false,
		updateQuestionType: "",
		updateWeightage: null,
		updateId: null,
	});

	useEffect(() => {
		if (
			createQuestionTypeAndWeightageComplete === APIStatus.FULFILLED ||
			updateQueTypeAndWeightageCompleted === APIStatus.FULFILLED ||
			delQueTypeAndWeightageComplete === APIStatus.FULFILLED
		) {
			dispatch(getAllQueTypeAndWeightage());
			handleCloseAddModal();
		}
	}, [createQuestionTypeAndWeightageComplete, updateQueTypeAndWeightageCompleted, delQueTypeAndWeightageComplete]);

	const fetchData = (pagination: PaginationWithNumber) => {
		if (pagination.pageNumber === 0) {
			dispatch(clearGetAllQueTypeAndWeightage());
		}
		// dispatch(getAllQueTypeAndWeightage());
	};

	const showModal = (row: QueTypeAndWeightage) => {
		setState((preValue) => ({
			...preValue,
			isUpdateNewModalOpen: true,
			updateQuestionType: row.name,
			updateWeightage: row.weightage,
			updateId: row.id,
		}));
	};

	const deleteClicked = (id: number) => {
		dispatch(clearDeleteQueTypeAndWeightage());
		deleteModal({
			id: id,
			content: "All questions under this type will be deleted. Are you sure you want to proceed?",
			delete: () => {
				dispatch(delQueTypeAndWeightage(id));
			},
		});
	};

	const handleAddNewModalOpen = () => {
		console.log("handleAddNewModalOpen");
		setState((preValue) => ({
			...preValue,
			isAddNewModalOpen: true,
		}));
	};

	const handleCloseAddModal = () => {
		setState((preValue) => ({ ...preValue, isAddNewModalOpen: false }));
	};

	const handleCloseUpdateModal = useCallback(() => {
		setState((preValue) => ({ ...preValue, isUpdateNewModalOpen: false }));
	}, []);

	return (
		<div className="overview_content_box result_listing_main_container d-flex flex-column px-4">
			<div className="overview_tool_box custom_main_form filter_container d-flex align-items-center justify-content-end pr-2">
				<button
					className="primary_border_btn min_height_36 font_16 min_width_100"
					onClick={() => handleAddNewModalOpen()}
				>
					Add <span className="pl-2">+</span>
				</button>
			</div>
			<div className="flex_1_1_10">
				<div className="custom_table_main_container table_container h-50">
					<Table
						loading={dataLoading}
						totalResults={totalCount}
						defaultSort=""
						headers={columns(showModal, deleteClicked)}
						tableData={tableData}
						// loading={false}
						fetchData={(e) => fetchData(e)}
					/>
				</div>
				<div className="negative_mark_container h-50">
					<NegativeMark />
				</div>
			</div>

			{state.isAddNewModalOpen && (
				<AddNewQuestiontypeWeightage state={state} modalType="add" onClose={handleCloseAddModal} />
			)}
			{state.isUpdateNewModalOpen && (
				<AddNewQuestiontypeWeightage modalType="update" state={state} onClose={handleCloseUpdateModal} />
			)}
		</div>
	);
};
